export default "__VITE_ASSET__DuZh2rON__"